export class AuthExpiredError extends Error {
  readonly code = 'auth_expired'
  constructor(message: string = 'Session expired. Sign in again to upload.') {
    super(message)
    this.name = 'AuthExpiredError'
  }
}

export function isAuthExpiredError(error: unknown): error is AuthExpiredError {
  return error instanceof AuthExpiredError || (error instanceof Error && error.name === 'AuthExpiredError')
}

